import Keycloak from 'keycloak-js';

export function getRealmRoles(keycloak: Keycloak): string[] {
  const tokenRoles = (
    keycloak.tokenParsed as { realm_access?: { roles?: string[] } } | undefined
  )?.realm_access?.roles;

  return keycloak.realmAccess?.roles ?? tokenRoles ?? [];
}

export async function needsKeycloakLogin(keycloak: Keycloak): Promise<boolean> {
  if (!keycloak.authenticated || !keycloak.token) {
    return true;
  }

  try {
    await keycloak.updateToken(5);
  } catch {
    return true;
  }

  if (keycloak.isTokenExpired(0)) {
    return true;
  }

  return getRealmRoles(keycloak).length === 0;
}
